import { render, staticRenderFns } from "./ProfileItem.vue?vue&type=template&id=dbad2ee2&scoped=true"
import script from "./ProfileItem.vue?vue&type=script&lang=js"
export * from "./ProfileItem.vue?vue&type=script&lang=js"
import style0 from "./ProfileItem.vue?vue&type=style&index=0&id=dbad2ee2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbad2ee2",
  null
  
)

export default component.exports